import oceanUI from '../oceanUI';
import themeConfig from './themeConfig';
import globalConfig from '../utiles/globalConfig';

const MAIN_HOST = globalConfig.getMainHost();
const THEME_CONFIG = themeConfig.getByHost(window.btoa(MAIN_HOST));

export default function (Vue) {
  Vue.use(oceanUI, THEME_CONFIG);
}
